import React from "react";
import { GoPencil } from "react-icons/go";

const WritePost = () => {
  return (
    <div className="btn_post d-md-none d-flex justify-content-center align-items-center rounded-circle">
      <GoPencil />
    </div>
  );
};

export default WritePost;
